module.exports = __webpack_public_path__ + "img/smartz-logo.d6e57042.svg";